import {Location, Building, QuoteTypes} from "api/quote";
import {Box} from "components/Box";
import {GridContainer} from "components/Grid";
import Field from "../../Field";
import LocationsForm, {BuildingForm} from "../shared/LocationsForm";
import FormTitle from "pages/RateQuoteBind/components/FormTitle";

export const homeConstructionTypes = [
  {label: "Frame", value: "1"},
  {label: "Masonry", value: "2"},
  {label: "Non-Combustible", value: "3"},
  {label: "Fire Resistive", value: "6"},
  {label: "Masonry Veneer", value: "5"},
  {label: "Masonry Non-Combustible", value: "4"},
];

export const newHomeConstructionTypes = [
  "Aluminium Sliding Over Frame",
  "Frame",
  "Masonry",
  "Masonry Veneer",
  "Plastic Sliding Over Frame",
  "Superior Construction",
];

export const windHailOptions = [
  {label: "0%", value: 0},
  {label: "1%", value: 1},
  {label: "2%", value: 2},
  {label: "5%", value: 5},
];

const roofTypeOptions = [
  "Asphalt Shingle & Others",
  "Build Up/Rolls",
  "Composition Shingles",
  "Metal",
  "Shake/Wood Shingle",
  "Slate",
  "Tile",
];

const filterOptionsByHO = (hoValue: string) => {
  switch (hoValue) {
    case "HO3":
    case "HO5":
      return [
        {title: "Residential Dwelling", value: "Residential Dwelling"},
        {title: "Town/Row House", value: "Town/Row house"},
        {title: "Apartment", value: "Apartment"},
      ];
    case "HO4":
      return [
        {title: "Residential Dwelling", value: "Residential Dwelling"},
        {title: "Apartment", value: "Apartment"},
        {title: "Cooperative Unit", value: "Cooperative Unit"},
      ];
    case "HO6":
      return [
        {title: "Condominium", value: "Condominium"},
        {title: "Cooperative Unit", value: "Cooperative Unit"},
      ];
    default:
      return [];
  }
};

const numberOfFamilyOptions = [
  {label: "1 Family", value: "One Family Dwelling"},
  {label: "2 Family", value: "Two Family Dwelling"},
];

const hoDeductibleOptions = [
  {title: "$500.00", value: 500},
  {title: "$1,000.00", value: 1000},
  {title: "$2,500.00", value: 2500},
];

const protectiveDeviceOptions = [
  "No Protective Device",
  "Central Station Reporting Burglar Alarm",
  "Central Station Reporting Fire Alarm",
  "Police Station Reporting Burglar Alarm",
  "Fire Department Reporting Fire Alarm",
  "Local Burglar and/or Fire Alarm",
  "Automatic Sprinklers (Incl)",
  "Automatic Sprinklers (Excl)",
  "Central Station Rept. Fire and Burglar Alarm",
  "Central Stat. Rept. Burglar Alarm Fire Dept. Rept. Fire Alarm",
  "Central Stat Rept. Burglar Alarm Local Fire Alarm",
  "Central Stat. Rept. Burglar Alarm Auto. Sprinklers (Incl)",
  "Central Stat. Rept. Burglar Alarm Auto. Sprinklers (Excl)",
  "Police Stat. Rept. Burglar Alarm Central Stat. Rept. Fire Al",
  "Police Stat. Rept. Burglar Alarm Fire Dept. Rept. Fire Alarm",
  "Police Station Rept. Burglar Alarm Local Fire Alarm",
  "Police Stat. Rept. Burglar Alarm Auto. Sprinklers (Incl)",
  "Police Stat. Rept. Burglar Alarm Auto. Sprinklers (Excl)",
  "Local Burglar Alarm Central Stat. Rept. Fire Alarm",
  "Local Burglar Alarm Fire Dept. Rept. Fire Alarm",
  "Local Burglar Alarm Automatic Sprinklers (Incl)",
  "Local Burglar Alarm Automatic Sprinklers (Excl)",
];

const hoPublicProtectionClassOptions = [
  "New York City",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
];

const acvOrRcOptions = ["ACV", "RC"];

const coverageBOptions = [
  {label: "10%", value: 10},
  {label: "None (Only available if no other structure exists)", value: 0},
];

const eLiabilityOptions = [
  {label: "$100,000", value: 100000},
  {label: "$200,000", value: 200000},
  {label: "$300,000", value: 300000},
  {label: "$400,000", value: 400000},
  {label: "$500,000", value: 500000},
];

const fMedicalOptions = [
  {label: "$1,000", value: 1000},
  {label: "$5,000", value: 5000},
];

const booleanOptions = ["Yes", "No"];

const lossesOptions = ["1", "2", "3", "4"];

function HomeBuildingForm({
  location,
  building,
  quoteType,
}: {
  location: Location;
  building: Building;
  quoteType: QuoteTypes;
}) {
  console.log(`the ho type: ${location.ho_policy_type}`);
  return (
    <GridContainer rowGap={24} columnGap={16}>
      <Field.DropDown
        object={building.home_building!}
        options={newHomeConstructionTypes.map((item) => ({
          title: item,
          value: item,
        }))}
        field={"construction_type"}
        label="Construction type"
        wrapperProps={{
          growXXS: 12,
          growMD: 6,
        }}
      />
      {(location.ho_policy_type === "HO3" ||
        location.ho_policy_type === "HO5") && (
        <Field.DropDown
          object={building.home_building!}
          options={numberOfFamilyOptions.map((item) => ({
            title: item.label,
            value: item.value,
          }))}
          field={"number_of_families"}
          label="Number of Families"
          wrapperProps={{
            growXXS: 12,
            growMD: 6,
          }}
        />
      )}
      {/* <Field.DropDown
        object={building.home_building!}
        options={isBuildingSprinklered.map((item) => ({
          title: item.label,
          value: item.value,
        }))}
        field={"is_building_sprinklered"}
        label="Is Building Sprinklered"
        wrapperProps={{
          growXXS: 12,
          growMD: 6,
        }}
      />
      <Field.TextInput
        object={building.home_building!}
        field={"number_of_units"}
        label="Number of units"
        isFormattedNumber
        wrapperProps={{
          growXXS: 12,
          growMD: 6,
        }}
      /> */}
      <Field.TextInput
        type="number"
        object={building.home_building!}
        field={"year_built"}
        label="Year built"
        wrapperProps={{
          growXXS: 12,
          growMD: 6,
        }}
      />
      <Field.DropDown
        object={building.home_building!}
        options={roofTypeOptions.map((item) => ({
          title: item,
          value: item,
        }))}
        field={"roof_type"}
        label="Roof Type"
        wrapperProps={{
          growXXS: 12,
          growMD: 6,
        }}
      />
      {location.ho_policy_type && (
        <Field.DropDown
          object={building.home_building!}
          options={filterOptionsByHO(location.ho_policy_type).map((item) => ({
            title: item.title,
            value: item.value,
          }))}
          field={"home_style"}
          label="Home Style"
          wrapperProps={{
            growXXS: 12,
            growMD: 6,
          }}
        />
      )}
      <Field.TextInput
        object={building.home_building!}
        field={"square_footage"}
        label="Square footage"
        isFormattedNumber
        wrapperProps={{
          growXXS: 12,
          growMD: 6,
        }}
      />
      <Field.DropDown
        object={building.home_building!}
        field={"ho_deductible"}
        label="HO Deductible"
        options={hoDeductibleOptions.map((item) => ({
          title: item.title,
          value: item.value,
        }))}
        wrapperProps={{
          growXXS: 12,
          growMD: 6,
        }}
      />
      <Field.DropDown
        object={building.home_building!}
        field={"protective_device"}
        label="Protective Device"
        options={protectiveDeviceOptions.map((item) => ({
          title: item,
          value: item,
        }))}
        wrapperProps={{
          growXXS: 12,
          growMD: 6,
        }}
      />
      <Field.DropDown
        object={building.home_building!}
        field={"ho_public_protection_class"}
        label="HO Public Protection Class"
        options={hoPublicProtectionClassOptions.map((item) => ({
          title: item,
          value: item,
        }))}
        wrapperProps={{
          growXXS: 12,
          growMD: 6,
        }}
      />
      {(location.ho_policy_type === "HO3" ||
        location.ho_policy_type === "HO5") && (
        <Field.TextInput
          object={building.home_building!}
          field={"a_dwelling"}
          label="A - Dwelling"
          isFormattedNumber
          wrapperProps={{
            growXXS: 12,
            growMD: 6,
          }}
        />
      )}
      {location.ho_policy_type === "HO6" && (
        <Field.TextInput
          object={building.home_building!}
          field={"a_dwelling"}
          label="Coverage A Optional"
          isFormattedNumber
          wrapperProps={{
            growXXS: 12,
            growMD: 6,
          }}
        />
      )}
      {(location.ho_policy_type === "HO3" ||
        location.ho_policy_type === "HO5") && (
        <Field.DropDown
          object={building.home_building!}
          options={coverageBOptions.map((item) => ({
            title: item.label,
            value: item.value,
          }))}
          field={"coverage_b"}
          label="Coverage B"
          wrapperProps={{
            growXXS: 12,
            growMD: 6,
          }}
        />
      )}
      <Field.DropDown
        object={building.home_building!}
        field={"acv_or_rc"}
        label="ACV or RC"
        options={acvOrRcOptions.map((item) => ({
          title: item,
          value: item,
        }))}
        wrapperProps={{
          growXXS: 12,
          growMD: 6,
        }}
      />
      {(location.ho_policy_type === "HO4" ||
        location.ho_policy_type === "HO6") && (
        <Field.TextInput
          object={building.home_building!}
          field={"coverage_c"}
          label="Coverage C"
          isFormattedNumber
          wrapperProps={{
            growXXS: 12,
            growMD: 6,
          }}
        />
      )}
      <Field.DropDown
        object={building.home_building!}
        options={eLiabilityOptions.map((item) => ({
          title: item.label,
          value: item.value,
        }))}
        field={"e_liability"}
        label="E - Liability"
        wrapperProps={{
          growXXS: 12,
          growMD: 6,
        }}
      />
      <Field.DropDown
        object={building.home_building!}
        options={fMedicalOptions.map((item) => ({
          title: item.label,
          value: item.value,
        }))}
        field={"f_medical"}
        label="F - Medical"
        wrapperProps={{
          growXXS: 12,
          growMD: 6,
        }}
      />
      <Field.DropDown
        object={building.home_building!}
        options={booleanOptions.map((item) => ({
          title: item,
          value: item,
        }))}
        field={"losses_reported"}
        label="Were any losses reported within the past three years?"
        wrapperProps={{
          growXXS: 12,
          growMD: 6,
        }}
      />

      {building.home_building?.losses_reported === "Yes" && (
        <Field.DropDown
          object={building.home_building!}
          options={lossesOptions.map((item) => ({
            title: item,
            value: item,
          }))}
          field={"number_of_losses_reported"}
          label="How many losses were reported within the past three years?"
          wrapperProps={{
            growXXS: 12,
            growMD: 6,
          }}
        />
      )}
      <Box mx={12} mt={12} width="100%">
        <Field.RadioGroup
          object={building.home_building!}
          field="roof_fully_replaced_within_25_years"
          label="Was the roof fully replaced within 25 years?"
          options={[
            {title: "Yes", value: 1},
            {title: "No", value: 0},
          ]}
        />
      </Box>
      <Box mb={50} mx={12}>
        <FormTitle.Header2>Endorsements</FormTitle.Header2>
        <GridContainer rowGap={24} columnGap={16}>
          <Field.CheckBox
            label="Water Back Up and Sump Discharge"
            object={building.home_building!}
            field={"water_back_up_and_sump_discharge"}
            wrapperProps={{
              grow: 12,
            }}
          />
          <Field.CheckBox
            label="Elite Protection"
            object={building.home_building!}
            field={"elite_protection"}
            wrapperProps={{
              grow: 12,
            }}
          />
          <Field.CheckBox
            label="HO 0420: Specified Add’l Amt of Ins Cov A"
            object={building.home_building!}
            field={"ho_0420_specified_addl_amt_of_ins_cov_a"}
            wrapperProps={{
              grow: 12,
            }}
          />
        </GridContainer>
      </Box>
      <Field.CheckBox
        label="Manual Wind/Hail Deductible - Field Only Available for AE Internal - UW"
        object={building.home_building!}
        field={"manual_wind_hail_coverage_flag"}
        wrapperProps={{
          grow: 12,
          style: {
            backgroundColor: "rgba(255, 255, 125)",
            borderTopLeftRadius: "6px",
            borderTopRightRadius: "6px",
            borderBottomLeftRadius: !building.home_building!
              .manual_wind_hail_coverage_flag
              ? "6px"
              : "0px",
            borderBottomRightRadius: !building.home_building!
              .manual_wind_hail_coverage_flag
              ? "6px"
              : "0px",
          },
        }}
      />
      {building.home_building!.manual_wind_hail_coverage_flag && (
        <Field.DropDown
          object={building.home_building!}
          field={"manual_wind_hail_coverage_percent"}
          label="Percentage"
          options={windHailOptions.map((option) => ({
            title: option.label,
            value: option.value,
          }))}
          wrapperProps={{
            growXXS: 12,
            growMD: 6,
            style: {
              backgroundColor: "rgba(255, 255, 125)",
              borderBottomLeftRadius: "6px",
              borderBottomRightRadius: "6px",
            },
          }}
        />
      )}
      {location.buildings.length > 1 ? (
        <Box mb={16} mt={12} mx={12}>
          <Field.RadioGroup
            object={building}
            field="building_within_100_ft_of_another"
            label="Is this building within 100 ft of another building in this location"
            options={[
              {title: "Yes", value: 1},
              {title: "No", value: 0},
            ]}
          />
        </Box>
      ) : (
        <></>
      )}
    </GridContainer>
  );
}

export default function HomeLocationsForm({
  locations,
  quoteId,
  quoteType = QuoteTypes.HOME,
}: {
  locations: Location[];
  quoteId: any;
  quoteType?: QuoteTypes;
}) {
  return (
    <LocationsForm
      quoteId={quoteId}
      locations={locations}
      quoteType={quoteType}
    >
      {({locationId, location, buildings}) => (
        <>
          {locations.length > 1 && (
            <Box mb={16}>
              <Field.RadioGroup
                object={location}
                field="building_within_100_ft_of_another"
                label="Are any buildings within 100 ft of another building in other location"
                options={[
                  {title: "Yes", value: 1},
                  {title: "No", value: 0},
                ]}
              />
            </Box>
          )}
          <BuildingForm
            locationId={location.id}
            location={location}
            buildings={location.buildings}
          >
            {({locationId, location, building}) => (
              <HomeBuildingForm
                location={location}
                building={building}
                quoteType={quoteType}
              />
            )}
          </BuildingForm>
        </>
      )}
    </LocationsForm>
  );
}
